export default "__VITE_ASSET__609d24e5__"